export const createPaymentsRequests = (client) => ({
    findPayment: async (payload) => {
        const { data } = await client.api.request({
            method: "GET",
            type: "payments",
            url: `payments/${payload?.filter?.id}`,
            params: payload,
        });
        return data;
    },
    initializePayment: async (payload) => {
        const { data } = await client.api.request({
            method: "POST",
            type: "payments",
            url: "payments",
            body: payload,
        });
        return data;
    },
});
//# sourceMappingURL=index.js.map